exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#forgotPasswordContainer{background-color:#fff;max-width:450px;margin:5px;padding:15px 10px 30px;border-radius:15px;-ms-flex-preferred-size:auto!important}#forgotPasswordContainer #submit{padding-left:10px;padding-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/containers/forgot-password/forgot-password.styl
// module id = 91
// module chunks = 1